import { useSyncExternalStore } from 'react';

// Which notifications have been read, remembered on this device only.
const KEY = 'serb-read-notifications';
const listeners = new Set<() => void>();

const read = (): string[] => {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '[]') as string[];
  } catch {
    return [];
  }
};
let snapshot = read();

function write(ids: string[]) {
  snapshot = ids;
  try {
    localStorage.setItem(KEY, JSON.stringify(ids));
  } catch {
    /* private window: the marks only last until the page is closed */
  }
  listeners.forEach((l) => l());
}

export const markRead = (ids: string[]) => write([...new Set([...snapshot, ...ids])]);

/** The ids marked read; the page re-draws when it changes */
export const useReadIds = (): string[] =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => snapshot,
  );
